import { dispatch } from '../index.js'
import {actionTypes} from '../../config'

export const dispatchAuthUser = (user) => {
    return dispatch({type: actionTypes.DISPATCH_AUTH_USER, user})
}

export const dispatchNonAuthUser = user => {
    return dispatch({type: actionTypes.DISPATCH_NON_AUTH_USER, user})
}